import { render, staticRenderFns } from "./AnimatedIconSuccess.vue?vue&type=template&id=bd06e580&scoped=true&"
import script from "./AnimatedIconSuccess.vue?vue&type=script&lang=js&"
export * from "./AnimatedIconSuccess.vue?vue&type=script&lang=js&"
import style0 from "./AnimatedIconSuccess.vue?vue&type=style&index=0&id=bd06e580&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../frontend-internal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd06e580",
  null
  
)

export default component.exports